import {mapMutations} from "vuex";
export default {
  name: "together",
  components:{
  },
  data(){
    return{

    }
  },
  props: {
    item: {
      type: Object,
default: () => ({ homeSection: { homeSectionImage: '', homeSectionTitle1: '', homeSectionTitle2: '', homeSectionText1: '', homeSectionText2: '' } })
    },
  },
  created() {
  },
  computed:{

  },
  methods:{
    ...mapMutations({
    })
  }
}
